import React from 'react';
import { Loader } from '@sdir/sds';
import { useIntl } from 'react-intl';
import { ErrorMessage } from '@sdir/utilities/lib/components';

interface LoadWrapperInterface {
  children: any;
  loading?: boolean;
  error: any;
  errorTitleId?: string;
}

export const LoadWrapper: React.FC<LoadWrapperInterface> = ({
  loading,
  error,
  errorTitleId,
  children,
}) => {
  const intl = useIntl();
  return loading && loading !== undefined ? (
    <Loader />
  ) : error ? (
    <ErrorMessage
      title={errorTitleId ? intl.formatMessage({ id: errorTitleId }) : undefined}
      error={error}
    />
  ) : (
    <>{children}</>
  );
};
